// Unspecified error on Internet Explorer with document.activeElement
// https://github.com/reactjs/react-tabs/issues/193
const canUseActiveElement = typeof window !== 'undefined' &&
    window.document &&
    // eslint-disable-next-line valid-typeof
    typeof window.document.activeElement !== 'unknown';
// inspired by https://gist.github.com/aFarkas/a7e0d85450f323d5e164
export const focusWithin = () => {
    const slice = [].slice;
    const removeClass = (elem) => {
        elem.classList.remove('focus-within');
    };
    const update = (() => {
        let running;
        let last;
        const action = () => {
            let element = canUseActiveElement ? document.activeElement : null;
            running = false;
            if (last !== element) {
                last = element;
                slice
                    .call(document.getElementsByClassName('focus-within'))
                    .forEach(removeClass);
                while (element && element.classList) {
                    element.classList.add('focus-within');
                    element = element.parentNode;
                }
            }
        };
        return () => {
            if (!running) {
                requestAnimationFrame(action);
                running = true;
            }
        };
    })();
    document.addEventListener('focus', update, true);
    document.addEventListener('blur', update, true);
    update();
    return {
        disengage() {
            document.removeEventListener('focus', update, true);
            document.removeEventListener('blur', update, true);
        },
    };
};
//# sourceMappingURL=focus.js.map